import { render, staticRenderFns } from "./CDkey.vue?vue&type=template&id=5fef523c&"
import script from "./CDkey.vue?vue&type=script&lang=js&"
export * from "./CDkey.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports